import {
  ContextData,
  contextDataToProductReference,
} from '../../common/context-data';
import {itemToYsoProductComponentModel} from './ysoProduct';
import {ProductType} from './product';
import {Quote} from './quote';
import {
  isOffer,
  itemToProductComponentModelServiceOffer,
} from './service-offer';
import {Bundle, Product} from '@sportngin/se-commerce-sdk/models/clare';

class ProductComponentModel<T extends ProductType> {
  constructor(
    public componentKey: string,
    public data: T,
    public title: string,
    public subtitle: string,
    public addToCartOnNext: boolean,
    public catalogId?: string,
  ) {}
}

function buildProductComponentModelFromItems(
  items: Array<Product | Bundle>,
  contextData: ContextData,
  quote?: Quote,
  catalogKey?: string,
): ProductComponentModel<ProductType> {
  const item = items[0];
  const ref = contextDataToProductReference(contextData);
  if (!!items[0].display_metadata && isOffer(items[0].display_metadata)) {
    return itemToProductComponentModelServiceOffer(
      item,
      quote,
      ref,
      catalogKey,
    );
  } else {
    return itemToYsoProductComponentModel(items, contextData, ref, catalogKey);
  }
}

/**
 * Converts Commerce SDK `BuyerProduct[]`, `ContextData` and an optional `Quote` into a
 * `ProductComponentModel<unknown>`.
 * @param buyerProducts products to be converted.
 * @param context session's current context-data.
 * @param quote optional quote to be assigned to the available service offer.
 */
function productComponentModelFactory(
  buyerProducts: Array<Product | Bundle>,
  context: ContextData,
  quote?: Quote,
  catalogKey?: string,
): ProductComponentModel<ProductType> {
  return buildProductComponentModelFromItems(
    buyerProducts,
    context,
    quote,
    catalogKey,
  );
}

export {ProductComponentModel, productComponentModelFactory};
